import { DeviceSettings } from './types';
import portsApi from '../framework/ports/portsApi';

const deviceInfo = {
  getDeviceInfo: (): Promise<DeviceSettings> =>
    portsApi.invoke('DeviceDetection.getDeviceInfo'),
};

export default deviceInfo;
